module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-dark-screens-4-2.ad623843.png";